export default __webpack_public_path__ + "static/media/MAYDOM2026.f933497c.png";